import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "main",
  style: {"width":"100%","height":"300px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_like_outlined = _resolveComponent("like-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_arrow_down_outlined = _resolveComponent("arrow-down-outlined")!
  const _component_arrow_up_outlined = _resolveComponent("arrow-up-outlined")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "总阅读量",
                          value: _ctx.statistic.viewCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "总点赞量",
                          value: _ctx.statistic.voteCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "点赞率",
                          value: _ctx.statistic.voteCount / _ctx.statistic.viewCount * 100,
                          precision: 2,
                          suffix: "%",
                          "value-style": { color: '#cf1322' }
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "今日阅读",
                          value: _ctx.statistic.todayViewCount,
                          style: {"margin-right":"50px"}
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "今日点赞",
                          value: _ctx.statistic.todayVoteCount
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_like_outlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "预计今日阅读",
                          value: _ctx.statistic.todayViewIncrease,
                          "value-style": { color: '#0000ff' }
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_UserOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic, {
                          title: "预计今日阅读增长",
                          value: _ctx.statistic.todayViewIncreaseRateAbs,
                          precision: 2,
                          suffix: "%",
                          class: "demo-class",
                          "value-style": _ctx.statistic.todayViewIncreaseRate < 0 ? { color: '#3f8600' } : { color: '#cf1322' }
                        }, {
                          prefix: _withCtx(() => [
                            (_ctx.statistic.todayViewIncreaseRate < 0)
                              ? (_openBlock(), _createBlock(_component_arrow_down_outlined, { key: 0 }))
                              : _createCommentVNode("", true),
                            (_ctx.statistic.todayViewIncreaseRate >= 0)
                              ? (_openBlock(), _createBlock(_component_arrow_up_outlined, { key: 1 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["value", "value-style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}